export interface OrgGradientColors {
  primary: string;
  secondary: string;
}

// Matches the brand gradient already used across the dashboard (PlayerDashboard.tsx,
// SeasonRegistrationForm.tsx, NationsLeague.tsx, etc.) so new sections look consistent.
export function getOrgGradientColors(orgSlug?: string): OrgGradientColors {
  if (orgSlug === "padel-eagle") {
    return { primary: "#743444", secondary: "#E49421" };
  }
  return { primary: "#667eea", secondary: "#764ba2" };
}

export function getOrgGradient(orgSlug?: string, angle = 135): string {
  const { primary, secondary } = getOrgGradientColors(orgSlug);
  return `linear-gradient(${angle}deg, ${primary} 0%, ${secondary} 100%)`;
}
